module.exports = __webpack_public_path__ + "img/k_narrow_pink.049870a4.png";